export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  REQUEST_SIDEMENU_STATE: 'REQUEST_SIDEMENU_STATE',
  SIDEMENU_STATE_CHANGED: 'SIDEMENU_STATE_CHANGED',
  MESSAGE_SENT: 'MESSAGE_SENT',
  FETCH_LABEL_SUGGESTIONS: 'FETCH_LABEL_SUGGESTIONS',
  TOGGLE_SIDEMENU: 'TOGGLE_SIDEMENU',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  EDITOR_CONTENT_CHANGED: 'EDITOR_CONTENT_CHANGED',
  TOGGLE_RIGHT_SIDEBAR: 'TOGGLE_RIGHT_SIDEBAR',
  // Il cliente ha scritto a Otello nella RightSidebar (la guida della mail di
  // prova dell'onboarding avanza al passo dell'invio).
  OTELLO_PROMPT_SENT: 'OTELLO_PROMPT_SENT',
  // Il cliente ha usato "Inserisci" o "Inserisci con Layout" sotto una
  // risposta di Otello (payload { modo: 'testo' | 'layout' }): la guida
  // dell'onboarding spunta il pulsante provato.
  OTELLO_INSERTED: 'OTELLO_INSERTED',
  // Una pagina ha cambiato il percorso di attivazione (payload: il Plan
  // nuovo), per esempio mandando la richiesta al webmaster: la guida lo rilegge.
  ONBOARDING_PLAN_CHANGED: 'ONBOARDING_PLAN_CHANGED',
  // Otello da mobile: apre/chiude l'assistente nel pannello dal basso.
  TOGGLE_MOBILE_ASSISTANT: 'TOGGLE_MOBILE_ASSISTANT',
  // Otello da mobile: azione del menu ⋮ della conversazione verso la lista.
  MOBILE_CONVERSATION_ACTION: 'MOBILE_CONVERSATION_ACTION',
  DRAFT_AUTO_GENERATED: 'DRAFT_AUTO_GENERATED',
  DRAFT_GENERATION_FAILED: 'DRAFT_GENERATION_FAILED',
  SCHEDULED_EMAIL_CREATED: 'SCHEDULED_EMAIL_CREATED',
  SCHEDULED_EMAIL_FAILED: 'SCHEDULED_EMAIL_FAILED',
  SCHEDULED_EMAIL_SENT: 'SCHEDULED_EMAIL_SENT',
  SCHEDULED_MESSAGE_CREATED: 'SCHEDULED_MESSAGE_CREATED',
  SCHEDULED_MESSAGE_FAILED: 'SCHEDULED_MESSAGE_FAILED',
  SCHEDULED_MESSAGE_SENT: 'SCHEDULED_MESSAGE_SENT',
};
